import HistoryIcon from "@material-ui/icons/History";

import ClientNotificationDeliveriesList from "./List/List";
import { ClientNotificationDeliveryShow } from "./Show/Show";

export const clientNotificationDeliveriesResource = {
	list: ClientNotificationDeliveriesList,
	show: ClientNotificationDeliveryShow,
	icon: HistoryIcon,
};
